import { Calendar } from '@fullcalendar/core';
import deLocale from '@fullcalendar/core/locales/de';
import interactionPlugin from '@fullcalendar/interaction';
import resourceTimelinePlugin from '@fullcalendar/resource-timeline';

import { Modal } from 'bootstrap';

document.addEventListener('DOMContentLoaded', function() {
	// add modal
	const add_modal = document.getElementById('einsatz_add_modal');
	const start_date = document.getElementById('einsatz_start');
	const end_date = document.getElementById('einsatz_end');
	// calendar
  	const calendarEl = document.getElementById('calendar');  	
  	var jsonUrl = '/de/saisonplanung/extern/json/';

  	if (calendarEl) {
  		// intern oder extern
  		let cal_type = calendarEl.dataset.info;
  		if (cal_type == 'intern') {
  			jsonUrl = '/de/saisonplanung/intern/json/';
  		}

		var calendar = new Calendar(calendarEl, {
			schedulerLicenseKey: '0405991452-fcs-1670863415',
			plugins: [ interactionPlugin, resourceTimelinePlugin ],
			locale: deLocale,
			selectable: true,
			height: 600,
			customButtons: {
    			datepickerButton: {
      				text: '',
      				icon: 'bi bi-calendar-week',
      				click: function (mouseEvent, htmlElement) {
      					var show_picker = false;
      					if (htmlElement.querySelector('#gotoDate')) {
      						show_picker = false;
      					} else {
      						htmlElement.innerHTML = '<input id="gotoDate" type="date" class="calendar-datepicker" name="gotoDate" value="">';
      						show_picker = true;
      					}
      					
        				const datepicker = htmlElement.querySelector('#gotoDate');
        				// on first click
        				if (show_picker === true) {
        					datepicker.showPicker();
        				};
        				
        				datepicker.addEventListener('change', (e) => {
        					var gotoDate = datepicker.value;
        					if (gotoDate) {
        						calendar.gotoDate(gotoDate);
        					}
        				});
      				}
    			}
  			},
		  	headerToolbar: {
		    	left: 'datepickerButton today prev,next',
		    	center: 'title',
		    	right: ''
		  	},
		  	initialView: 'resourceTimelineWeek',
		  	slotDuration: { day: 1},
		  	resourceGroupField: 'region',
		  	eventDidMount: function(info) {
		  		let selector = info.el.querySelector('.fc-event-main-frame');
		  		if (selector) {
		  			selector.innerHTML = info.event.extendedProps.description + '<h3>' + info.event.title + '</h3>';
		  		}
		  	},
		  	resourceAreaHeaderContent: 'Datum',
		  	resourceAreaWidth: '15%',
		  	resources: [
		    	{ id: 'de', region: 'Deutschschweiz', title: 'Einsätze' },
		    	{ id: 'fr', region: 'Romandie', title: 'Einsätze' },
		    	{ id: 'it', region: 'Ticino', title: 'Einsätze' }
		  	],
		  	dateClick: function(info) {
    			const clickDate = info.dateStr;
    			// add to modal form
    			start_date.setAttribute('value', clickDate);
    			end_date.setAttribute('value', clickDate);
    			
    			// open modal
    			const addNewModal = new Modal(add_modal);
            	addNewModal.show();
  			},
			events: jsonUrl
		});

		calendar.render();
  	};
});